import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import StringUtils from '../../../../components/utils/StringUtils';

import LabeledContainer from '../../../common/LabeledContainer';
import FormErrorMessage from '../../../../atoms/FormErrorMessage';
import TextInput, { TextInputType } from '../../../../atoms/TextInput';
import secretImage from '../../../../../public/static/books/secret.png';
import css from './MerchantProductProtectedPage.module.scss';
import implProductRepository from '../../../../infrastructure/repositories/ProductRepository';
import { SubmitButton } from '../../../../atoms/SubmitButton';

interface Props {
  publicId: string;
  productPublicId: string;
  onSubmit: (result: boolean) => void;
}

const MerchantProductProtectedPage: React.FC<Props> = ({
  publicId,
  productPublicId,
  onSubmit,
}) => {
  const intl = useIntl();
  const [password, setPassword] = useState<string>('');
  const [posted, setPosted] = useState<boolean>(false);
  const [posting, setPosting] = useState<boolean>(false);
  const [result, setResult] = useState<boolean>(false);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.currentTarget.value);
  }, []);

  const handleSubmit = useCallback(async () => {
    setPosting(true);

    const verifyResult = await implProductRepository.PasswordVerify(
      publicId,
      productPublicId,
      password,
    );

    setPosted(true);
    setPosting(false);
    setResult(verifyResult);
    onSubmit(verifyResult);
  }, [onSubmit, password, publicId, productPublicId]);

  const classes = classNames(css.MerchantProductProtectedPage);

  return (
    <div className={classes}>
      <img
        className={css.MerchantProductProtectedPage__Img}
        src={secretImage}
        alt=""
      />
      <dl className={css.MerchantProductProtectedPage__Notes}>
        <dt className={css.MerchantProductProtectedPage__Heading}>
          {intl.formatMessage({ id: 'merchants.secret.notes.heading' })}
        </dt>
        <dd className={css.MerchantProductProtectedPage__Description}>
          {StringUtils.nl2br(
            intl.formatMessage({
              id: 'merchants.secret.notes.description',
            }),
          )}
        </dd>
      </dl>
      <div className={css.MerchantProductProtectedPage__Password}>
        <LabeledContainer
          label={intl.formatMessage({ id: 'merchants.secret.password' })}
          errorStyle={posted && !result}
        >
          <TextInput
            type={TextInputType.Password}
            value={password}
            onChange={handleChange}
          />
        </LabeledContainer>
        {posted && !result && (
          <FormErrorMessage>
            {intl.formatMessage({ id: 'merchants.secret.errorMessages' })}
          </FormErrorMessage>
        )}
      </div>
      <SubmitButton
        type="button"
        disabled={!password || posting}
        postable={!posting}
        onClick={handleSubmit}
        small={true}
        value={intl.formatMessage({
          id: 'books.submitLabel.ok',
        })}
      >
        {intl.formatMessage({
          id: 'books.submitLabel.ok',
        })}
      </SubmitButton>
    </div>
  );
};

export default MerchantProductProtectedPage;
